// src/pages/Archive/index.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './index.css';

const Archive = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = () => {
    try {
      // 从 localStorage 获取文章数据
      const articlesData = JSON.parse(localStorage.getItem('articles') || '[]');
      setArticles(articlesData);
    } catch (error) {
      console.error('获取文章失败:', error);
    }
  };

  // 按月份分组文章
  const groupArticlesByMonth = () => {
    const grouped = {};
    
    articles.forEach(article => {
      const date = new Date(article.date);
      const monthKey = `${date.getFullYear()}年${date.getMonth() + 1}月`;
      
      if (!grouped[monthKey]) {
        grouped[monthKey] = [];
      }
      grouped[monthKey].push(article);
    });
    
    return grouped;
  };

  const groupedArticles = groupArticlesByMonth();

  return (
    <div className="archive-page">
      <h1>文章归档</h1>
      <div className="archive-content">
        {Object.keys(groupedArticles).length > 0 ? (
          Object.keys(groupedArticles).map(month => (
            <div key={month} className="month-section">
              <div className="month-header">
                <span className="month-icon">📅</span>
                <h3>{month}</h3>
              </div>
              <div className="articles-list">
                {groupedArticles[month].map(article => (  // ✅ 正确：使用 groupedArticles
                  <div key={article.id} className="article-item">
                    <h4 className="article-title">
                      <Link to={`/post?id=${article.id}`} className="article-link">
                        {article.title}
                      </Link>
                    </h4>
                    <div className="article-meta">
                      <span className="article-date">{article.date}</span>
                      <span className="article-tags">
                        {Array.isArray(article.tags) ? 
                          article.tags.map(tag => (
                            <span key={tag} className="tag">{tag}</span>
                          )) : 
                          article.tags.split(',').map(tag => (
                            <span key={tag} className="tag">{tag.trim()}</span>
                          ))
                        }
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        ) : (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <p>暂无文章</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Archive;